// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__S0N6l"};